import Popver from "./popver/index";
import CallApp from "@alife/callapp";
import { isOurApp, isDingTalk, isUC, isWeChat, isAlipay } from "./util/useragent";
import $ from "zepto-modules";

/**
 * 绑定事件 a链接唤起
 */
import { appendParams } from "./util/qs";

let alreadyProxied = false;
export default (data, config, url, additionQuery = {}) => {

  if (!data.attrAbtest || isAlipay) return;

  // 支付宝小程序需要通过schema进入, 需要唤起
  if ((isOurApp && !isDingTalk && !isUC) || isWeChat) {
    //不做唤起逻辑 走a标签之前的逻辑·
    return true;
  }

  if (alreadyProxied) return;
  alreadyProxied = true;

  function preventDefault(e) {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }
  }

  function goToA(href,additionQuery) {
    if (isAlipay && window.ap) {
      window.ap.pushWindow({
        url: href,
        data: additionQuery,
        params: {
          showLoading: "NO",
          transparentTitle: "none",
          pullRefresh: "NO",
          showOptionMenu: showOptionMenu ? "YES" : "NO",
          showProgress: "YES"
        }
      });
    } else {
      window.location.href = appendParams(href, additionQuery);
    }
  }


  document.addEventListener("click", function (e) {
    if(e.target.tagName == "A"){
      e.preventDefault();
    }
    function composedPath(el) {
      var path = [];
      while (el) {
        path.push(el);
        if (el.tagName === "HTML") {
          path.push(document);
          path.push(window);
          return path;
        }
        el = el.parentElement;
      }
    }
    var path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
    if (path) {
      Array.prototype.forEach.call(path, function (el) {
        if ("A" === el.tagName) {
          // 此时的 href 已经被 aplus patch
          var href = el.href;
          let callAttrRegex = data.callAttrRegex;
          let _reg = new RegExp(callAttrRegex);

          if (_reg.test(href)) {
            if (data.attrPopverAbtest) {
              //是否弹窗唤起
              Popver.init({
                imgUrl: (config && config.manual) ? data.manualImage : data.popverImage,
                success: function () {
                  //打点
                  config && config.success && config.success();
                  if (window['goldlog'] && goldlog.record) {
                    let dpid = goldlog.pvid;
                    goldlog.record('/1688seo.tinyapp.fronttinyapp', 'CLK', 'dpid=' + dpid, 'GET');
                  }
                  CallApp.gotoPage(url);
                },
                close: function () {
                  config && config.close && config.close();
                  if (window['goldlog'] && goldlog.record) {
                    let dpid = goldlog.pvid;
                    goldlog.record('/1688seo.tinyapp.frontcancel', 'CLK', 'dpid=' + dpid, 'GET');
                  }
                  goToA(href,additionQuery);
                },
                goWebLogin: function () {
                  config && config.goWebLogin && config.goWebLogin();
                  //还是打取消的按钮
                  if (window['goldlog'] && goldlog.record) {
                    let dpid = goldlog.pvid;
                    goldlog.record('/1688seo.tinyapp.frontcancel', 'CLK', 'dpid=' + dpid, 'GET');
                  }
                  goToA(href,additionQuery);
                }
              });
              if (window['goldlog'] && goldlog.record) {
                let dpid = goldlog.pvid;
                goldlog.record('/1688seo.tinyapp.silentcall', 'CLK', 'dpid=' + dpid, 'GET')
              }
              CallApp.gotoPage(url);
              preventDefault(e);

            } else {
              if (window['goldlog'] && goldlog.record) {
                let dpid = goldlog.pvid;
                goldlog.record('/1688seo.tinyapp.silentcall', 'CLK', 'dpid=' + dpid, 'GET')
              }
              CallApp.gotoPage(url);
              preventDefault(e);
            }
          }
        }
      });
    }
  });
};


// WEBPACK FOOTER //
// ./src/bindEvent.js